import { createSelector } from '@reduxjs/toolkit';
import tableSelector from './table';

const pageInfoSelector = createSelector(tableSelector, (table) => table.pageInfo);

export default pageInfoSelector;
